module.exports = __webpack_public_path__ + "static/media/simiyu.918f8f6b.jpg";